(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toneaglow-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tg-ba-carousel')) {
    class TgBaCarousel extends HTMLElement {
      #scrollTimer = null;
      #resizeTimer = null;
      #teleporting = false;

      connectedCallback() {
        this.track = this.querySelector('[data-tgba-track]');
        if (!this.track) return;

        this.realCards = Array.from(this.track.querySelectorAll('[data-tgba-card]'));
        this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
        this.loop = this.dataset.loop === 'true' && this.realCards.length > 1 && !this.designMode;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (this.loop) this.#buildClones();

        this.querySelector('[data-tgba-prev]')?.addEventListener('click', () => this.#step(-1));
        this.querySelector('[data-tgba-next]')?.addEventListener('click', () => this.#step(1));

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.#step(-1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.#step(1); }
        });

        if ('onscrollend' in window) {
          this.track.addEventListener('scrollend', () => this.#onSettled());
        } else {
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.#scrollTimer);
            this.#scrollTimer = setTimeout(() => this.#onSettled(), 140);
          }, { passive: true });
        }

        window.addEventListener('resize', () => {
          clearTimeout(this.#resizeTimer);
          this.#resizeTimer = setTimeout(() => this.#recenter(), 150);
        });

        if (this.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const card = event.target.closest?.('[data-tgba-card]');
            if (card && this.track.contains(card)) this.#scrollToCard(card, true);
          });
        }

        if (this.loop) {
          requestAnimationFrame(() => this.#jumpToReal(0));
        }
      }

      get #allCards() {
        return Array.from(this.track.querySelectorAll('[data-tgba-card]'));
      }

      #buildClones() {
        const count = Math.min(this.realCards.length, 4);
        const head = this.realCards.slice(0, count).map((card) => this.#clone(card));
        const tail = this.realCards.slice(-count).map((card) => this.#clone(card));
        for (const clone of tail.reverse()) this.track.prepend(clone);
        for (const clone of head) this.track.append(clone);
      }

      #clone(card) {
        const clone = card.cloneNode(true);
        clone.dataset.tgbaClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        return clone;
      }

      #behavior(instant) {
        if (instant || this.reducedMotion.matches) return 'auto';
        return 'smooth';
      }

      #scrollToCard(card, smooth) {
        const target = this.#targetLeft(card);
        this.track.scrollTo({ left: target, behavior: smooth ? this.#behavior(false) : 'auto' });
      }

      #targetLeft(card) {
        /* Aligne la carte sur sa position de snap (start desktop / center mobile). */
        const style = getComputedStyle(card);
        if (style.scrollSnapAlign.includes('center')) {
          return card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2;
        }
        return card.offsetLeft;
      }

      #nearestIndex() {
        const cards = this.#allCards;
        let best = 0;
        let bestDist = Infinity;
        for (let i = 0; i < cards.length; i += 1) {
          const dist = Math.abs(this.#targetLeft(cards[i]) - this.track.scrollLeft);
          if (dist < bestDist) { bestDist = dist; best = i; }
        }
        return best;
      }

      #step(direction) {
        const cards = this.#allCards;
        let index = this.#nearestIndex() + direction;
        if (!this.loop) {
          /* Sans boucle : on revient au début / à la fin (wrap visible). */
          if (index < 0) index = cards.length - 1;
          if (index > cards.length - 1) index = 0;
        } else {
          index = Math.max(0, Math.min(cards.length - 1, index));
        }
        this.#scrollToCard(cards[index], true);
      }

      #onSettled() {
        if (!this.loop || this.#teleporting) return;
        const cards = this.#allCards;
        const current = cards[this.#nearestIndex()];
        if (!current || current.dataset.tgbaClone !== 'true') return;
        const realIndex = Number(current.dataset.tgbaIndex);
        this.#jumpToReal(realIndex);
      }

      #jumpToReal(realIndex) {
        const target = this.#allCards.find(
          (card) => !card.dataset.tgbaClone && Number(card.dataset.tgbaIndex) === realIndex
        );
        if (!target) return;
        this.#teleporting = true;
        this.track.scrollTo({ left: this.#targetLeft(target), behavior: 'auto' });
        requestAnimationFrame(() => { this.#teleporting = false; });
      }

      #recenter() {
        const cards = this.#allCards;
        const current = cards[this.#nearestIndex()];
        if (current) this.#scrollToCard(current, false);
      }
    }

    customElements.define('tg-ba-carousel', TgBaCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toneaglow-how-to-use"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousels() {
    for (const carousel of document.querySelectorAll('[data-tg-howto-carousel]')) {
      if (carousel.dataset.initialized) continue;
      carousel.dataset.initialized = 'true';

      const track = carousel.querySelector('[data-tg-howto-track]');
      const prevBtn = carousel.querySelector('[data-tg-howto-prev]');
      const nextBtn = carousel.querySelector('[data-tg-howto-next]');

      if (!track) continue;

      function updateButtons() {
        if (!prevBtn || !nextBtn) return;
        const scrollLeft = track.scrollLeft;
        const maxScroll = track.scrollWidth - track.clientWidth;

        // At the start
        if (scrollLeft <= 5) {
          prevBtn.setAttribute('disabled', 'true');
        } else {
          prevBtn.removeAttribute('disabled');
        }

        // At the end
        if (scrollLeft >= maxScroll - 5) {
          nextBtn.setAttribute('disabled', 'true');
        } else {
          nextBtn.removeAttribute('disabled');
        }
      }

      function scroll(direction) {
        const slides = Array.from(track.children);
        if (slides.length === 0) return;

        const scrollLeft = track.scrollLeft;
        let currentIndex = 0;
        let minDiff = Infinity;

        // Find slide closest to current scroll position
        for (let i = 0; i < slides.length; i++) {
          const diff = Math.abs(slides[i].offsetLeft - scrollLeft);
          if (diff < minDiff) {
            minDiff = diff;
            currentIndex = i;
          }
        }

        // Target index
        let targetIndex = currentIndex;
        if (direction === 'next') {
          targetIndex = Math.min(currentIndex + 1, slides.length - 1);
        } else {
          targetIndex = Math.max(currentIndex - 1, 0);
        }

        const targetSlide = slides[targetIndex];
        if (targetSlide) {
          const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const targetScrollLeft = targetSlide.offsetLeft - (track.clientWidth - targetSlide.clientWidth) / 2;

          track.scrollTo({
            left: targetScrollLeft,
            behavior: isReduced ? 'auto' : 'smooth'
          });
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => scroll('prev'));
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => scroll('next'));
      }

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });

      updateButtons();
      setTimeout(updateButtons, 100);
    }
  }

  function initVideos() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    for (const root of document.querySelectorAll('[data-tg-howto-video-root]')) {
      if (root.dataset.videoInitialized === 'true') continue;

      const videos = Array.from(root.querySelectorAll('[data-tg-howto-video]'));
      if (videos.length === 0) continue;

      root.dataset.videoInitialized = 'true';
      let observer = null;

      function automaticPlaybackDisabled() {
        if (reduceMotion.matches) return true;
        if (!connection) return false;
        if (connection.saveData) return true;
        return ['slow-2g', '2g', '3g'].includes(connection.effectiveType);
      }

      function pauseOtherVideos(activeVideo) {
        for (const video of videos) {
          if (video !== activeVideo) video.pause();
        }
      }

      function loadAndPlay(video) {
        if (!video) return;

        const source = video.dataset.src;
        if (!source) return;

        if (!video.src) {
          video.preload = 'metadata';
          video.src = source;
          video.load();
        }

        pauseOtherVideos(video);
        video.muted = true;
        video.defaultMuted = true;

        const playPromise = video.play();
        if (playPromise?.catch) playPromise.catch(() => {});
      }

      function playMostVisibleVideo() {
        if (automaticPlaybackDisabled() || document.hidden) {
          pauseOtherVideos(null);
          return;
        }

        let candidate = null;
        let bestRatio = 0;

        for (const video of videos) {
          const ratio = Number.parseFloat(video.dataset.visibilityRatio || '0');
          if (ratio > bestRatio) {
            candidate = video;
            bestRatio = ratio;
          }
        }

        if (!candidate || bestRatio < 0.25) {
          pauseOtherVideos(null);
          return;
        }

        loadAndPlay(candidate);
      }

      function startObserver() {
        if (observer || automaticPlaybackDisabled() || !('IntersectionObserver' in window)) return;

        observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              entry.target.dataset.visibilityRatio = entry.isIntersecting
                ? String(entry.intersectionRatio)
                : '0';
              if (!entry.isIntersecting) entry.target.pause();
            }
            playMostVisibleVideo();
          },
          {
            rootMargin: '80px 0px',
            threshold: [0, 0.25, 0.5, 0.75, 1]
          }
        );

        for (const video of videos) observer.observe(video);
      }

      function handlePreferenceChange() {
        if (automaticPlaybackDisabled()) {
          observer?.disconnect();
          observer = null;
          for (const video of videos) video.dataset.visibilityRatio = '0';
          pauseOtherVideos(null);
          return;
        }

        startObserver();
        playMostVisibleVideo();
      }

      function handleVisibilityChange() {
        if (document.hidden) pauseOtherVideos(null);
        else playMostVisibleVideo();
      }

      for (const video of videos) {
        const media = video.closest('.tg-howto__media');

        video.addEventListener('play', () => pauseOtherVideos(video));
        video.addEventListener('error', () => {
          media?.setAttribute('data-video-loaded', 'error');
          video.removeAttribute('src');
          video.load();
        });
      }

      startObserver();
      reduceMotion.addEventListener?.('change', handlePreferenceChange);
      connection?.addEventListener?.('change', handlePreferenceChange);
      document.addEventListener('visibilitychange', handleVisibilityChange);

      root.tgHowToVideoDestroy = () => {
        observer?.disconnect();
        reduceMotion.removeEventListener?.('change', handlePreferenceChange);
        connection?.removeEventListener?.('change', handlePreferenceChange);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        pauseOtherVideos(null);
      };
    }
  }

  function initAll() {
    initCarousels();
    initVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target?.querySelectorAll) return;
    for (const root of event.target.querySelectorAll('[data-tg-howto-video-root]')) {
      root.tgHowToVideoDestroy?.();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toneaglow-image-marquee"] && !Shopify.designMode) return;
  try {
    
  class ToneaglowImageMarquee extends HTMLElement {
    #onResize;

    connectedCallback() {
      this.track = this.querySelector('[data-tg-track]');
      if (!this.track) return;

      this.firstGroup = this.track.querySelector('[data-tg-group]');
      if (!this.firstGroup) return;

      this.speed = parseFloat(this.dataset.speed) || 60;

      this.#onResize = this.#debounce(() => this.#build(), 200);

      this.#build();

      window.addEventListener('resize', this.#onResize);

      for (const img of this.firstGroup.querySelectorAll('img')) {
        if (!img.complete) img.addEventListener('load', this.#onResize, { once: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.#onResize);
    }

    #build() {
      for (const clone of this.track.querySelectorAll('[data-tg-clone]')) {
        clone.remove();
      }
      this.removeAttribute('data-animate');

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const groupWidth = this.firstGroup.getBoundingClientRect().width;
      if (groupWidth === 0) return;

      const distance = groupWidth + gap;
      const hostWidth = this.getBoundingClientRect().width;
      const copies = Math.max(2, Math.ceil(hostWidth / distance) + 1);

      for (let i = 1; i < copies; i++) {
        const clone = this.firstGroup.cloneNode(true);
        clone.setAttribute('data-tg-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(clone);
      }

      this.style.setProperty('--tg-distance', `${distance}px`);
      this.style.setProperty('--tg-duration', `${distance / this.speed}s`);
      this.setAttribute('data-animate', '');
    }

    #debounce(fn, wait) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  if (!customElements.get('toneaglow-image-marquee')) {
    customElements.define('toneaglow-image-marquee', ToneaglowImageMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toneaglow-image-showcase"] && !Shopify.designMode) return;
  try {
    
  class ToneaglowImageShowcase extends HTMLElement {
    #observer;
    #onResize;

    connectedCallback() {
      const entrance = this.dataset.entrance;

      if (entrance && entrance !== 'none') {
        this.#observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.setAttribute('data-visible', '');
              this.#observer.disconnect();
            }
          },
          { threshold: 0.15 }
        );
        this.#observer.observe(this);
      } else {
        this.setAttribute('data-visible', '');
      }

      this.#onResize = this.#debounce(() => this.#adjustOverflow(), 150);
      window.addEventListener('resize', this.#onResize);
      this.#adjustOverflow();
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      window.removeEventListener('resize', this.#onResize);
    }

    #adjustOverflow() {
      const wrapper = this.querySelector('[data-tg-wrapper]');
      const bg = this.querySelector('[data-tg-bg]');
      const overlay = this.querySelector('[data-tg-overlay]');

      if (!wrapper || !bg || !overlay) return;

      wrapper.style.removeProperty('padding-bottom');

      if (window.innerWidth < 750) return;

      requestAnimationFrame(() => {
        const bgBottom = bg.getBoundingClientRect().bottom;
        const overlayBottom = overlay.getBoundingClientRect().bottom;
        const overflow = overlayBottom - bgBottom;

        if (overflow > 0) {
          wrapper.style.paddingBottom = `${Math.ceil(overflow)}px`;
        }
      });
    }

    #debounce(fn, wait) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  if (!customElements.get('toneaglow-image-showcase')) {
    customElements.define('toneaglow-image-showcase', ToneaglowImageShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toneaglow-results-30-days"] && !Shopify.designMode) return;
  try {
    
  class ToneaglowResultsCounter extends HTMLElement {
    #animationFrame = null;
    #counterContainer = null;
    #hasPlayed = false;
    #isAnimating = false;
    #observer = null;

    connectedCallback() {
      this.#counterContainer = this.querySelector('[data-counter-container]');
      if (!this.#counterContainer) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const canObserve = 'IntersectionObserver' in window;

      if (this.dataset.animate !== 'true' || reducedMotion || !canObserve) {
        this.#showFinalValues();
        return;
      }

      this.#resetCounters();

      const threshold = Number.parseFloat(this.dataset.threshold || '0.5');
      this.#observer = new IntersectionObserver(
        ([entry]) => this.#handleIntersection(entry),
        { threshold }
      );
      this.#observer.observe(this.#counterContainer);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      if (this.#animationFrame) cancelAnimationFrame(this.#animationFrame);
    }

    #handleIntersection(entry) {
      if (entry.isIntersecting) {
        this.#animateCounters();
        return;
      }

      if (this.dataset.replay === 'true' && (this.#hasPlayed || this.#isAnimating)) {
        this.#resetCounters();
      }
    }

    #animateCounters() {
      if (this.#isAnimating || this.#hasPlayed) return;

      const counters = Array.from(this.querySelectorAll('[data-counter]'));
      if (counters.length === 0) return;

      const duration = Math.max(100, Number.parseInt(this.dataset.duration || '1000', 10));
      const easing = this.dataset.easing || 'linear';
      const startTime = performance.now();
      this.#isAnimating = true;

      const update = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easing === 'ease-out'
          ? 1 - Math.pow(1 - progress, 3)
          : progress;

        for (const counter of counters) {
          const target = Number.parseInt(counter.dataset.target || '0', 10);
          const value = progress === 1 ? target : Math.floor(target * easedProgress);
          counter.textContent = this.#formatValue(counter, value);
        }

        if (progress < 1) {
          this.#animationFrame = requestAnimationFrame(update);
          return;
        }

        this.#animationFrame = null;
        this.#hasPlayed = true;
        this.#isAnimating = false;

        if (this.dataset.replay !== 'true') this.#observer?.disconnect();
      };

      this.#animationFrame = requestAnimationFrame(update);
    }

    #resetCounters() {
      if (this.#animationFrame) cancelAnimationFrame(this.#animationFrame);
      this.#animationFrame = null;
      this.#hasPlayed = false;
      this.#isAnimating = false;

      for (const counter of this.querySelectorAll('[data-counter]')) {
        counter.textContent = this.#formatValue(counter, 0);
      }
    }

    #showFinalValues() {
      for (const counter of this.querySelectorAll('[data-counter]')) {
        const target = Number.parseInt(counter.dataset.target || '0', 10);
        counter.textContent = this.#formatValue(counter, target);
      }
    }

    #formatValue(counter, value) {
      return `${counter.dataset.prefix || ''}${value}${counter.dataset.suffix || ''}`;
    }
  }

  if (!customElements.get('toneaglow-results-counter')) {
    customElements.define('toneaglow-results-counter', ToneaglowResultsCounter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toneaglow-temoignages-video-bulles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (!root || root.dataset.ugcInit) return;
      root.dataset.ugcInit = 'true';

      var dialog = root.querySelector('.ugc-modal');
      var player = dialog ? dialog.querySelector('[data-ugc-player]') : null;
      if (!dialog || !player) return;

      var shouldLoop = root.getAttribute('data-ugc-loop') === 'true';
      var previewVideos = Array.from(root.querySelectorAll('[data-ugc-preview]'));
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var previewObserver = null;
      var previewTimer = null;

      function autoPreviewsDisabled() {
        if (reduceMotion.matches) return true;
        if (!connection) return false;
        if (connection.saveData) return true;
        return connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g';
      }

      function clearPreviewTimer() {
        if (!previewTimer) return;
        window.clearTimeout(previewTimer);
        previewTimer = null;
      }

      function pausePreviews(hideVideo) {
        clearPreviewTimer();
        previewVideos.forEach(function (video) {
          video.pause();
          if (hideVideo) video.classList.remove('is-playing');
        });
      }

      function playPreview(video) {
        if (!video || autoPreviewsDisabled() || dialog.open || document.hidden) return;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = shouldLoop;
        if (!video.src) {
          video.src = video.getAttribute('data-src');
          video.load();
        }
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      }

      function scheduleVisiblePreviews() {
        if (autoPreviewsDisabled() || dialog.open || document.hidden) return;

        previewVideos.forEach(function (video) {
          if (video.dataset.ugcInView === 'true' && video.src) playPreview(video);
        });

        if (previewTimer) return;
        var nextVideo = previewVideos.find(function (video) {
          return video.dataset.ugcInView === 'true' && !video.src;
        });
        if (!nextVideo) return;

        playPreview(nextVideo);
        previewTimer = window.setTimeout(function () {
          previewTimer = null;
          scheduleVisiblePreviews();
        }, 800);
      }

      previewVideos.forEach(function (video) {
        video.addEventListener('playing', function () {
          video.classList.add('is-playing');
        });
      });

      function startPreviewObserver() {
        if (previewObserver || autoPreviewsDisabled() || !previewVideos.length) return;
        if (!('IntersectionObserver' in window)) return;
        previewObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            entry.target.dataset.ugcInView = entry.isIntersecting ? 'true' : 'false';
            if (!entry.isIntersecting) entry.target.pause();
          });
          scheduleVisiblePreviews();
        }, { rootMargin: '0px', threshold: 0.5 });
        previewVideos.forEach(function (video) { previewObserver.observe(video); });
      }

      startPreviewObserver();

      function handleAutoplayPreferenceChange() {
        if (autoPreviewsDisabled()) {
          if (previewObserver) previewObserver.disconnect();
          previewObserver = null;
          pausePreviews(true);
          return;
        }
        startPreviewObserver();
        scheduleVisiblePreviews();
      }

      function handleVisibilityChange() {
        if (document.hidden) pausePreviews(false);
        else scheduleVisiblePreviews();
      }

      if (typeof reduceMotion.addEventListener === 'function') reduceMotion.addEventListener('change', handleAutoplayPreferenceChange);
      else reduceMotion.addListener(handleAutoplayPreferenceChange);
      if (connection && typeof connection.addEventListener === 'function') connection.addEventListener('change', handleAutoplayPreferenceChange);
      document.addEventListener('visibilitychange', handleVisibilityChange);

      function clear() { player.innerHTML = ''; }

      function open(mp4, poster) {
        if (!mp4) return;
        pausePreviews(false);
        clear();
        var v = document.createElement('video');
        v.src = mp4;
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        v.controls = true;
        v.autoplay = true;
        if (shouldLoop) {
          v.loop = true;
          v.setAttribute('loop', '');
        }
        if (poster) v.poster = poster;
        player.appendChild(v);

        // Ouvrir la modale AVANT de lancer la lecture. Garde-fou anti double-open.
        if (!dialog.open) {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        }

        // Le clic est un geste utilisateur : tentative son actif, sinon fallback muet.
        var p = v.play();
        if (p && p.catch) { p.catch(function () { v.muted = true; v.play().catch(function () {}); }); }
      }

      function close() {
        if (dialog.open && typeof dialog.close === 'function') dialog.close();
        else {
          dialog.removeAttribute('open');
          clear();
          scheduleVisiblePreviews();
        }
      }

      root.querySelectorAll('[data-ugc-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          open(btn.getAttribute('data-mp4'), btn.getAttribute('data-poster'));
        });
      });

      dialog.querySelectorAll('[data-ugc-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      dialog.addEventListener('close', function () {
        clear();
        scheduleVisiblePreviews();
      });

      root.ugcDestroy = function () {
        if (previewObserver) previewObserver.disconnect();
        if (typeof reduceMotion.removeEventListener === 'function') reduceMotion.removeEventListener('change', handleAutoplayPreferenceChange);
        else reduceMotion.removeListener(handleAutoplayPreferenceChange);
        if (connection && typeof connection.removeEventListener === 'function') connection.removeEventListener('change', handleAutoplayPreferenceChange);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        pausePreviews(true);
      };
    }

    function initAll() { document.querySelectorAll('.ugc-stories').forEach(initSection); }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector('.ugc-stories') : null;
      if (el) initSection(el); else initAll();
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector('.ugc-stories') : null;
      if (el && el.ugcDestroy) el.ugcDestroy();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
